
import Vue from "vue";
import Hero from "@/components/Hero.vue";

export default Vue.extend({
  data: () => ({
    navs: [
      ["ホーム", "home"],
      ["会社概要", "about"],
      ["サービス", "service"],
      ["採用", "recruit"],
      ["お問い合わせフォームへ", "contact"],
    ],
    iframeSrc: process.env.VUE_APP_CHAT_URL as string,
    userIP: "",
    viewportChangeHandler: null as (() => void) | null
  }),
  metaInfo() {
    return {
      title: "株式会社村田ソフトウェアサービス",
      meta: [
        {
          name: "description",
          content:
            "株式会社村田ソフトウェアサービスは、受託開発とSES事業を手がけるソフトウェア開発会社です。Webシステムやスマートフォンアプリ開発を通じて、お客様の目標達成を最後までサポートします。お見積りやご相談はお気軽にお問い合わせください。",
        },
      ],
    };
  },
  mounted: function () {
    this.$nextTick(async () => {
      this.adjustScale();
      window.addEventListener("resize", this.adjustScale);
      this.setupMobileKeyboardHandling();
      this.getIP();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustScale);
    this.cleanupMobileKeyboardHandling();
  },
  components: {
    Hero,
  },
    methods: {
      async getIP() {
        try {
          const response = await fetch('https://api.ipify.org?format=json');
          const data = await response.json();
          this.userIP = data.ip;
        } catch (error) {
          // IPアドレス取得失敗時は無視
        }
        this.sendContext();
      },
      sendContext() {

        const frame = this.$refs.chatFrame as HTMLIFrameElement | undefined;
      if (!frame || !frame.contentWindow) return;

      // 送信先オリジン（iframeSrc から算出）
      let targetOrigin = "*";
      try {
        targetOrigin = new URL(this.iframeSrc, window.location.href).origin;
      } catch (error) {
        // URL解析失敗時は無視
      }


      frame.contentWindow.postMessage(
        {
          ref: document.referrer,
          ip:this.userIP
        },
        targetOrigin
      );
      // デバッグ用
      // console.log('postMessage sent to', targetOrigin);
    },
    adjustScale: function () {
      const screenWidth = window.innerWidth;
      const scaleValue = screenWidth / 1920;
      const transformValue = `scale(${scaleValue})`;
      const target = document.getElementsByClassName("hero_main")[0] as HTMLDivElement;
      if (target) {
        target.style.transform = transformValue;
      } else {
        console.error("Target element not found");
      }
    },
    setupMobileKeyboardHandling: function () {
      // モバイルでのキーボード表示/非表示の検知
      let initialViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      let isKeyboardOpen = false;

      const handleViewportChange = () => {
      const currentHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const heightDiff = initialViewportHeight - currentHeight;

      // キーボードが開いた場合
      if (heightDiff > 150 && !isKeyboardOpen) {
        isKeyboardOpen = true;
        console.log('キーボードが開きました');
      }
      // キーボードが閉じた場合
      else if (heightDiff <= 50 && isKeyboardOpen) {
        isKeyboardOpen = false;
        console.log('キーボードが閉じました');

        // 少し遅延させてiframe位置を調整
        setTimeout(() => {
          const chatFrame = this.$refs.chatFrame as HTMLElement;
          if (chatFrame) {
            const rect = chatFrame.getBoundingClientRect();
            const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

            console.log('=== デバッグ情報 ===');
            console.log('iframe TOP位置:', rect.top);
            console.log('iframe BOTTOM位置:', rect.bottom);
            console.log('iframe 高さ:', rect.height);
            console.log('ビューポート高さ:', viewportHeight);
            console.log('現在のスクロール位置:', window.scrollY);

            // iframeの下端を画面下端に合わせるためのスクロール位置を計算
            // 現在のスクロール位置 + (iframeの下端 - ビューポート高さ) + マージン
            const targetScrollY = window.scrollY + (rect.bottom - viewportHeight) + 20;

            console.log('目標スクロール位置:', targetScrollY);

            window.scrollTo({
              top: targetScrollY,
              behavior: 'smooth'
            });
          }
        }, 100); // 100ms遅延
      }
    };


      // Visual Viewport APIがサポートされている場合
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', handleViewportChange);
        this.viewportChangeHandler = handleViewportChange;
      }
      // フォールバック：window.resizeイベント
      else {
        window.addEventListener('resize', handleViewportChange);
        this.viewportChangeHandler = handleViewportChange;
      }
    },
    cleanupMobileKeyboardHandling: function () {
      if (this.viewportChangeHandler) {
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this.viewportChangeHandler);
        } else {
          window.removeEventListener('resize', this.viewportChangeHandler);
        }
        this.viewportChangeHandler = null;
      }
    },
  },
});
